export const cart = {
  cart: {
    cartDetails: {
      id: 'ID',
      proceedToCheckout: 'Proceed to Checkout',
      cartName: 'Cart #{{code}}',
      title: 'Your Shopping Cart',
    },
    cartItems: {
      id: 'ID',
      description: 'Description',
      item: 'Item',
      itemPrice: 'Your Price',
      quantity: 'Qty',
      quantityTitle: 'The quantity represents the total number of this item in your cart.',
      total: 'Total',
      actions: 'Actions',
      cartTotal: 'Cart Total ({{count}} item)',
      cartTotal_other: 'Cart Total ({{count}} items)',
      itemRemoved: 'The selected item has been removed. The cart total has been updated.',
      caption: 'Contents of the shopping cart.',
      quoteNumber: 'Quote Number',
      cartTotalPriceTitle: 'Total Price',
      cartUnitPriceTitle: 'Your Price',
      poLineNumber: 'PO Line Number',
      poLine: 'PO Line',
      poLineNumberInfo:
        'If you have a PO Line for this item, you can enter it here for your own reference. The PO # that applies to the entire order will be entered on the next page.',
      addNotes: 'Add Notes',
      editNotes: 'Edit Notes',
      actualShipDate: 'Actual Ship Date',
      estShipDate: 'Est. Ship Date',
      remainingItems: 'The remaining items will be shipped once available.',
      reqShipDate: 'Req. Ship Date',
      reqShipDateInfo: 'All orders placed after {{cutOffTime}} will ship if available next business day.',
      freeDeliveryWarning: 'Add {{amount}} more to qualify for FREE SHIPPING.',
      freeDeliverySuccess: 'Cart is eligible for free shipping',
      nonReturnableItemWarning: 'Please review details before purchase.',
      nonReturnableCartWarning: 'Your cart includes one or more non-returnable items. <br/> By completing your purchase, you agree that these products are final sale and not eligible for returns.',
      warehouseHover: 'Click to change your Warehouse selection',
      quantityInStock: '({{quantityInStock}} items)',
      quantityInfo:
        'Once an item has been customized and added to your cart, the selected quantity cannot be modified directly in the cart. If you need to adjust the quantity, please return to the product page, select the configurator, make the necessary changes, and re-add the item to your cart.',
    },
    orderCost: {
      orderSummary: 'Order Summary',
      orderPricingSummary: 'Order Pricing Summary',
      subtotal: 'Order Subtotal:',
      shipping: 'Shipping:',
      estimatedShipping: 'Estimated Shipping:',
      discount: 'You saved:',
      salesTax: 'Sales Tax:',
      grossTax: 'The total order does not include taxes of',
      grossIncludeTax: 'The total order includes taxes of',
      total: 'Total:',
      toBeDetermined: 'To be determined',
      totalWeight: 'Total Weight',
    },
    voucher: {
      coupon: 'Have a coupon?',
      coupon_other: 'Coupon Codes',
      couponLabel: 'Enter a promotional code here',
      apply: 'Apply',
      placeholder: 'Promotional Code',
      applyVoucherSuccess: '{{voucherCode}} has been applied.',
      removeVoucherSuccess: '{{voucherCode}} has been removed.',
      anchorLabel: 'Enter or remove your coupon code',
      vouchersApplied: 'Coupons applied',
      availableCoupons: 'Available coupons',
      availableCouponsLabel: 'You can add these coupons to this order.',
    },
    saveForLaterItems: {
      itemTotal: 'Saved for later ({{count}} item)',
      itemTotal_other: 'Saved for later ({{count}} items)',
      cartTitle: 'Cart',
      saveForLater: 'Save for Later',
      moveToCart: 'Move to Cart',
      stock: 'Stock',
      forceInStock: 'In Stock',
    },
    clearCart: {
      clearCart: 'Clear Cart',
      clearingCart: 'Clearing Cart...',
      cartClearedSuccessfully: 'Active cart cleared successfully.',
      areYouSureToClearCart: 'Are you sure you want to clear this cart?',
      allItemsWillBeRemoved: 'All items in your active cart will be removed.',
      cancel: 'Cancel Clear Cart',
      close: 'Close Clear Cart Dialog',
      crossClick: 'Cross click',
      closeMaster: 'close dialog on component destroy',
    },
    validation: {
      cartEntriesChangeDuringCheckout:
        'During checkout, we encountered issues with your entries. Please review your cart.',
      cartEntryRemoved: '{{name}} has been removed from the cart due to insufficient stock.',
      productOutOfStock: '{{name}} has been removed from the cart due to insufficient stock.',
      lowStock: 'Quantity has been reduced to {{quantity}} due to insufficient stock.',
      reviewConfiguration: 'Resolve the configuration issues for the cart entry first.',
      configurationError: 'Resolve the configuration issues for the cart entries first.',
      pricingError:
        'The configurator price is currently unavailable. Shipping/quotation is not possible. Please try again later.',
      unresolvableIssues:
        'The product configuration requires additional inputs in the backend. As a result, you cannot proceed. Please contact support.',
      inProgress: 'In Progress',
      nullWarehouse: 'The product {{productName}} does not have an identified warehouse. Please contact support.',
      nullWarehouseMultiple: 'The following product(s) do not have an identified warehouse: {{productsWithError}}. Please contact support.',
      unknownProduct: 'Unknown product',
    },
    configDetails: {
      currency: 'Currency',
      totalPrice: 'Total Price',
      table: {
        header: {
          type: 'Type',
          name: 'Name',
          description: 'Description',
          quantity: 'Quantity',
          unitPrice: 'Your Price',
          extendedPrice: 'Extended Price',
        },
      },
      blankLines: 'Blank Lines Data',
    },
    importEntries: {
      importProducts: 'Import Products',
      fileUploaded: 'File uploaded: {{fileName}}',
    },
    quickOrder: {
      addUpTo25Products: 'You can only add up to 25 products at a time.',
      clearAllEntries: 'Clear all entries',
      addToCart: 'Add To Cart',
    },
    addToCart: {
      itemsAddedToYourCart: 'Items added to your cart',
      itemsIncrementedInYourCart: 'Items incremented in your cart',
      viewCart: 'View Cart',
      proceedToCheckout: 'Proceed to Checkout',
      updatingCart: 'Updating cart...',
      closeModal: 'Close modal',
      priceZeroException: 'Price Zero Exception',
      priceZeroExceptionRequestQuote: 'Request a Quote',
      priceZeroExceptionFinalMessage: 'to get a price for this item.',
      quantity: 'Qty',
      outOfStock: 'Out of stock',
      inStock: 'In stock',
      addToCart: 'Add to cart',
      buyItAgain: 'Buy Again',
    },
    modifyMotors: {
      noContent: 'No Content',
    },
    cartEmpty: {
      yourShoppingCartIsEmpty: 'Your shopping cart is empty',
      continueShopping: 'Continue Shopping',
    },
    cartItemListRow: {
      status: 'Status',
      part: 'Part',
      catalog: 'Catalog',
    },
    modalSeeNotes: {
      cancel: 'Cancel',
      save: 'Save',
    },
  },
};

export const clearCart = {
  clearCart: {
    clearCart: 'Clear Cart',
    cartClearedSuccessfully: 'Active cart cleared successfully.',
    clearingCart: 'Clearing Cart...',
    areYouSureToClearCart: 'Are you sure you want to clear this cart?',
    allItemsWillBeRemoved: 'All items in your active cart will be removed.',
    cancel: 'Cancel Clear Cart',
    close: 'Close Clear Cart Dialog',
    crossClick: 'Cross click',
    closeMaster: 'close dialog on component destroy',
  },
};

export const cartItems = {
  cartItems: {
    cartTotal: 'Cart Total ({{count}} item)',
  },
};
